export default {"src":"/_next/static/media/us_airforce.cdde8a46.svg","height":90,"width":90,"blurWidth":0,"blurHeight":0};